module.exports = __webpack_public_path__ + "static/media/zind_rugarama10.50a1ce31.jpg";